import './index.css';

import * as serviceWorker from './serviceWorker';

import App from './App';
import { ContextStoreProvider } from './store/contextStore';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry } from './sentrySetup';
import { store } from './app/store';
import theme from './theme';

// Before anything can record the URL: on the signup host this strips the invite code from it first.
initSentry();

ReactDOM.render(
    <React.StrictMode>
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <ContextStoreProvider>

                   <Provider store={store}>
                    <App />
                    </Provider>
                </ContextStoreProvider>
            </ThemeProvider>
        </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
